export default __webpack_public_path__ + "static/media/youtube_logo.42f1483a.svg";